import { Flex, Text, useBreakpointValue, Box, Heading } from "@chakra-ui/react";

import { useColorModeValue } from "../../../components/ui/color-mode";

export const FeatureListItem = ({ icon: IconComp, heading, text, isReversed }) => {
    // Define breakpoints for responsive layout
    const direction = useBreakpointValue({ base: "column", md: isReversed ? "row-reverse" : "row" });
    const iconSize = useBreakpointValue({ base: "64px", md: "100px" });
    const textColor = useColorModeValue("primary.700", "primary.100");
    const bgColor = useColorModeValue("primary.100", "primary.700");

    return (
        <Flex
            direction={direction}
            align="stretch"
            justifyContent="center"
            w="100%"
            minH={{ base: "auto", md: "250px" }}
            backgroundColor={bgColor}
            boxShadow="base"
            mb={10}
            p={5}
            borderRadius="xl"
        >
            <Flex
                direction="column"
                align="center"
                justifyContent="center"
                flex="2"
                py={{ base: 4, md: 0 }}
            >
                <Box boxSize={iconSize} color={textColor} display="flex" alignItems="center" justifyContent="center">
                    <IconComp size="100%" />
                </Box>
                <Heading as="h3" size={{ base: "md", md: "lg" }} mb={3} textAlign="center" color={textColor}>
                    {heading}
                </Heading>
            </Flex>
            <Box
                flex="2"
                display="flex"
                alignItems="center"
                justifyContent="center"
                p={{ base: 3, md: 5 }}
            >
                <Text textAlign="center" w="full" color={textColor} fontSize={{ base: "md", md: "xl" }}>
                    {text}
                </Text>
            </Box>
        </Flex>
    );
};

const FeatureComponent = ({ items }) => {
    return (
        <Box mx="auto" w="100%" p={[4, null, 8]}>
            {items.map((item, index) => (
                <FeatureListItem
                    key={index}
                    icon={item.icon}
                    heading={item.heading}
                    text={item.text}
                    isReversed={index % 2 !== 0}
                />
            ))}
        </Box>
    );
};

export default FeatureComponent;
